module.exports = __webpack_public_path__ + "static/media/021-tornado.cd683fb0.svg";